import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { InputLabel, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
export default function MultiImageUpload({ label, onChange, value = [] }) {
    const theme = useTheme();

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        onChange(files);
    };

    return (
        <Box>
            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.primary.default }}>
                {label}
            </InputLabel>
            <Box
                component="label"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 1,
                    p: 2,
                    textAlign: 'center',
                    backgroundColor: theme.palette.background.input,
                    mt: 1
                }}
            >
                <Typography variant="body2" color="textSecondary">
                    اختر الصور الفرعية
                </Typography>
                <VisuallyHiddenInput
                    type="file"
                    accept="image/*,.svg"
                    multiple
                    onChange={handleFileChange}
                />
            </Box>
        </Box>
    );
}